export const prerender = true;

import { browser } from '$app/env';
import posthog from 'posthog-js';

export const load = async () => {
	if (browser) {
		posthog.init('phc_lSxIv962Gi8ktRuaqixmdWsobMnwZSdm6awLy2DPPN', {
			opt_out_capturing_persistence_type: 'localStorage',
			api_host: 'https://ph.zarpar.eu',
			ui_host: 'https://eu.i.posthog.com',
			person_profiles: 'always',
			custom_campaign_params: ['source', 'camp'],
			disable_surveys: true
		});
	}
	return;
};
